import { TEST_IDS } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer
      data-testid={TEST_IDS.FOOTER.root}
      className="bg-cream border-t border-plum/5 py-16 lg:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-1 mb-4">
              <span className="font-serif text-xl font-semibold text-plum">
                You Belong Club
              </span>
              <span className="w-2 h-2 rounded-full bg-amber" />
            </div>
            <p className="text-sm text-plum-light leading-relaxed max-w-xs">
              The stuff that's a pain to shop for in person — bought in peace,
              with zero side-eye.
            </p>
          </div>

          {/* Shop */}
          <div>
            <h4 className="font-sans font-semibold text-sm uppercase tracking-widest text-plum mb-4">
              Shop
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#wear" className="text-sm text-plum-light hover:text-plum transition-colors duration-200">
                  Wear
                </a>
              </li>
              <li>
                <a href="#big-living" className="text-sm text-plum-light hover:text-plum transition-colors duration-200">
                  Big Living
                </a>
              </li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h4 className="font-sans font-semibold text-sm uppercase tracking-widest text-plum mb-4">
              About
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#manifesto" className="text-sm text-plum-light hover:text-plum transition-colors duration-200">
                  Our Manifesto
                </a>
              </li>
              <li>
                <span className="text-sm text-plum-light">
                  hello@youbelongclub.com
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-plum/5 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-plum-muted">
            &copy; {new Date().getFullYear()} You Belong Club. All rights reserved.
          </p>
          <p className="text-xs text-plum-muted">
            Made with care, for people who deserve it.
          </p>
        </div>
      </div>
    </footer>
  );
}
